import {
  TextInput,
  TextInputProps,
} from 'components/FormUtils/TextInput/text-input'
import { FieldValues } from 'react-hook-form'
import { cn } from 'components/UI/cn'

export function FilterTextInput<T extends FieldValues>(
  props: Omit<TextInputProps<T>, 'getInputClassName'>
) {
  const getFilterClassName = (isFocused: boolean, hasValue: boolean) => {
    return cn({
      '!border !border-new-company-green-active': isFocused, // Active
      '!border !border-new-company-green-dark': !isFocused && hasValue, // Filled
      '!border !border-new-company-gray-inactive': !isFocused && !hasValue, // Empty
    })
  }

  return <TextInput {...props} getInputClassName={getFilterClassName} />
}
